angular.module('impactx.userlist').controller('UserGroupSelectionController', [
    '$scope',
    '$mdDialog',
    'trns',
    'userGroups',
    'themeFactory',
    'TranslationService',
    '$redirect',
    UserGroupSelectionController]);

function UserGroupSelectionController($scope, $mdDialog, trns, userGroups, themeFactory, TranslationService, $redirect)
{
    $scope.title = trns.userGroupSelectionTitle;
    $scope.abortLabel = TranslationService.get('abort');
    $scope.theme = themeFactory.getTheme();
    $scope.userGroups = userGroups;

    this.cancel = function ()
    {
        $mdDialog.cancel();
    };

    this.redirect = function (id) {
        $redirect.redirectTo(null, '/usergroup/' + id);
        $mdDialog.cancel();
    };

}